import { Container } from 'react-bootstrap'
import styled from 'styled-components'

export default styled(Container)`
  padding-top: 50px;
  /* height: calc(100vh - 70px); */
  /* overflow-x: hidden; */
  /* overflow-y: auto; */
`
